import { useMemo } from 'react'
import { useDebounce } from '../../../../../../_metronic/helpers'
import { useListFilters } from './ListFiltersProvider'
import { useQueryResponse } from './QueryResponseProvider'
import { NotaProfissionalList } from './_models'

/** Atendimentos da nota, filtrados no client pelo protocolo. */
export const useAtendimentosFiltrados = (): NotaProfissionalList[] => {
  const { responseSemPaginacao: nota } = useQueryResponse()
  const { filters } = useListFilters()
  const busca = useDebounce(filters.protocolo, 300).trim().toLowerCase()

  return useMemo(() => {
    const todos = nota?.atendimentos ?? []
    if (!busca) return todos
    return todos.filter((item) => item.atendimento?.protocolo?.toLowerCase().includes(busca))
  }, [nota?.atendimentos, busca])
}
